var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeLasso(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 108,
    viewBox: "0 0 242 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240.815 60.3425C239.086 95.8643 185.85 109.409 119.671 106.189C53.4919 102.969 -0.569663 84.2032 1.15874 48.6814C2.88715 13.1596 59.5375 -1.30569 125.717 1.91444C191.896 5.13456 242.543 24.8207 240.815 60.3425Z",
    stroke: "#F68712",
    strokeWidth: 2.18667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeLasso);
export default __webpack_public_path__ + "static/media/orange-lasso.db48c7b29f3a710a270e30ed8c64db11.svg";
export { ForwardRef as ReactComponent };